import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'Components';
import './SearchField.css';

const SearchField = props => (
  <div className={`search-field ${props.className}`}>
    { props.title && <div className="search-field__label">{props.title}</div> }
    <Input
      value={props.value}
      placeholder={props.placeholder}
      onChange={props.onChange}
      onKeyPress={props.onKeyPress}
    />
    <i className="material-icons">search</i>
    { props.required && <span className="text-field__required">*</span> }
  </div>);

SearchField.propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
};

SearchField.defaultProps = {
  required: false,
  className: '',
};

export default SearchField;



// WEBPACK FOOTER //
// ./src/components/SearchField/SearchField.jsx